import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

export const VisitReferralsDetails = ({
  referrals,
  referralsRef,
  handleFileDownload,
}) => {
  if (!Array.isArray(referrals) || referrals.length === 0) {
    return null;
  }

  const formatDateWithoutConversion = (date) => {
    if (!date) {
      return '-';
    }

    const value = String(date);
    const datePart = value.substring(0, 10);
    const timePart = value.substring(11, 16);

    if (!datePart) {
      return '-';
    }

    if (!timePart || timePart === '00:00') {
      return datePart;
    }

    return `${datePart} ${timePart}`;
  };

  const formatDateOnlyWithoutConversion = (date) => {
    if (!date) {
      return '-';
    }

    return String(date).substring(0, 10);
  };

  return (
    <div ref={referralsRef} className="mt-3">
      {referrals.map((referral, index) => (
        <Card key={index} className="mb-4">
          <CardHeader>
            <Heading variant="userAccountDetailsTitle">Siuntimas</Heading>
          </CardHeader>

          <CardContent className="space-y-4">
            <div>
              <span>Data: </span>
              <span>
                {formatDateWithoutConversion(referral.occurrenceDateTime)}
              </span>
            </div>

            <div>
              <span>Gydytojas: </span>
              <span>
                {referral.practitioner.qualification} -{' '}
                {referral.practitioner.name} {referral.practitioner.surname}
              </span>
            </div>

            <div>
              <span>Diagnozė: </span>
              <span>{referral.reason}</span>
            </div>

            <div>
              <span>Kokiam specialistui siuntimas parašytas: </span>
              <span>{referral.specialty}</span>
            </div>

            <div>
              <span>Siuntimo tikslas:</span>
              {referral.intent?.split(/\r?\n|<br\/>/).map((text, i) => (
                <div key={i}>{text}</div>
              ))}
            </div>

            <div>
              <span>Galioja iki: </span>
              <span>{formatDateWithoutConversion(referral.validUntil)}</span>
            </div>

            {referral.file?.guid && (
              <div>
                <Button
                  variant="light"
                  onClick={() => {
                    const fileName = `${
                      referral.practitioner.qualification
                    }-${referral.practitioner.name} ${
                      referral.practitioner.surname
                    } ${formatDateOnlyWithoutConversion(
                      referral.occurrenceDateTime,
                    )}`;

                    handleFileDownload(
                      'Referral',
                      fileName,
                      referral.file.type,
                      referral.file.guid,
                    );
                  }}
                >
                  <Download />
                  Atsisiųsti PDF
                </Button>
              </div>
            )}
          </CardContent>

          <CardFooter />
        </Card>
      ))}
    </div>
  );
};